import styled from 'styled-components'

export const InfoBoxContainer = styled.div`
  ${({ theme }) => theme.map.infoBox.container.style}
`
